module.exports = __webpack_public_path__ + "img/signin_heedi.37c0bba6.png";